import React from "react";
import config from "../../../../../config";
import WalletTransactionStore from "../../../stores/wallet/wallet-transaction-store";
import {WALLET_TRANSACTION_ENUM} from "../../../../../services/api/wallet-service";
import Currency from "../../../../../components/currency/currency";


interface ITransactionDescriptionProps {
    transaction: WalletTransactionStore
}

const RefundTransactionDescription: React.FC<ITransactionDescriptionProps> = ({ transaction }) => {
    return (
        <>
            Void shipping label (RMA <a href={config.apiUrl + '/dashboard/returns?filter_status=all&rmaid=' + transaction.returnId} target="_parent">{transaction.returnId}</a>)
        </>
    );
}

const ManualDepositTransactionDescription: React.FC<ITransactionDescriptionProps> = ({ transaction }) => {
    return (
        <>
            Manually added <Currency amount={Number(transaction.amount)} currencyCode={transaction.currency} useNative={true} />
        </>
    );
}

const AutoDepositTransactionDescription: React.FC<ITransactionDescriptionProps> = ({ transaction }) => {
    return (
        <>
            Added <Currency amount={Number(transaction.amount)} currencyCode={transaction.currency} useNative={true} /> based on auto-recharge settings
        </>
    );
}

const ShippingLabelWithdrawalDescription: React.FC<ITransactionDescriptionProps> = ({ transaction }) => {
    return (
        <>Return shipping label (RMA <a href={config.apiUrl + '/dashboard/returns?filter_status=open&rmaid=' + transaction.returnId} target="_parent">{transaction.returnId}</a>)</>
    )
}

const TransactionDescription: React.FC<ITransactionDescriptionProps> = ({ transaction }) => {
    let DescriptionComponent: React.ElementType<ITransactionDescriptionProps> | null = null;

    if (transaction.type === WALLET_TRANSACTION_ENUM.TYPE_REFUND) {
        DescriptionComponent = RefundTransactionDescription;
    } else if (transaction.returnId) {
        DescriptionComponent = ShippingLabelWithdrawalDescription;
    }
    else if (transaction.type === WALLET_TRANSACTION_ENUM.TYPE_AUTO_DEPOSIT) {
        DescriptionComponent = AutoDepositTransactionDescription;
    }
    else if (transaction.type === WALLET_TRANSACTION_ENUM.TYPE_MANUAL_DEPOSIT) {
        DescriptionComponent = ManualDepositTransactionDescription;
    }

    return (
        <span className="transaction-description">
        {
            DescriptionComponent !== null
                ? <DescriptionComponent transaction={transaction}/>
                : transaction.reason ?? '-'
        }
        </span>
    )
};

export default TransactionDescription;
